export const GET_ADMIN_ROLES_REQUEST = "GET_ADMIN_ROLES_REQUEST";
export const GET_ADMIN_ROLES_SUCCESS = "GET_ADMIN_ROLES_SUCCESS";
export const GET_ADMIN_ROLES_FAIL = "GET_ADMIN_ROLES_FAIL";

export const CREATE_ADMIN_ROLES_REQUEST = "CREATE_ADMIN_ROLES_REQUEST";
export const CREATE_ADMIN_ROLES_SUCCESS = "CREATE_ADMIN_ROLES_SUCCESS";
export const CREATE_ADMIN_ROLES_FAIL = "CREATE_ADMIN_ROLES_FAIL";

export const UPDATE_ADMIN_ROLES_REQUEST = "UPDATE_ADMIN_ROLES_REQUEST";
export const UPDATE_ADMIN_ROLES_SUCCESS = "UPDATE_ADMIN_ROLES_SUCCESS";
export const UPDATE_ADMIN_ROLES_FAIL = "UPDATE_ADMIN_ROLES_FAIL";

export const GET_ADMIN_DID_CARRIER_REQUEST = "GET_ADMIN_DID_CARRIER_REQUEST";
export const GET_ADMIN_DID_CARRIER_SUCCESS = "GET_ADMIN_DID_CARRIER_SUCCESS";
export const GET_ADMIN_DID_CARRIER_FAIL = "GET_ADMIN_DID_CARRIER_FAIL";

export const CREATE_ADMIN_DID_CARRIER_REQUEST = "CREATE_ADMIN_DID_CARRIER_REQUEST";
export const CREATE_ADMIN_DID_CARRIER_SUCCESS = "CREATE_ADMIN_DID_CARRIER_SUCCESS";
export const CREATE_ADMIN_DID_CARRIER_FAIL = "CREATE_ADMIN_DID_CARRIER_FAIL";

export const UPDATE_ADMIN_DID_CARRIER_REQUEST = "UPDATE_ADMIN_DID_CARRIER_REQUEST";
export const UPDATE_ADMIN_DID_CARRIER_SUCCESS = "UPDATE_ADMIN_DID_CARRIER_SUCCESS";
export const UPDATE_ADMIN_DID_CARRIER_FAIL = "UPDATE_ADMIN_DID_CARRIER_FAIL";